export const handleOtherPackagingTransition = (aggregation, orderFrequency, newPackagingValue, setAggregation) => {
    const predefinedSku = aggregation?.[orderFrequency]?.[newPackagingValue]?.sku;
    setAggregation({
        orderFrequency,
        packagingPreference: newPackagingValue,
        predefinedSku,
    });
};
//# sourceMappingURL=handleOtherPackagingTransition.js.map